import { Navigate } from 'react-router';

export const NoAccess = () => <Navigate to="/" replace />;
